import LoadManager from './loadmanager.service';

export default LoadManager;
